import { useSetAtom } from "jotai";

import { $duplicateDocumentWorkflow } from "../../internal/document";

export const useDuplicateDocument = () => {
	return useSetAtom($duplicateDocumentWorkflow);
};
